var exports = {
  "v": "x2b2fbebb--1be00c--tabs",
};

module.exports = exports;
